export default __webpack_public_path__ + "3caf2b740a221a8fc5ad3ff6a4b61c59.png";